// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Harian_table_wrapper__SpQ1e"};